import React from 'react'
import PropTypes from 'prop-types'

const CommissionSummaryCard = ({
    loading,
    agentName,
    agentData,
    earningsData,
    commissionDetailData,
    t,
    formatCurrency,
    formatDate
}) => {
    const getAgentValue = (value) => {
        if (value === null || value === undefined || value === '') return '-'
        return value
    }

    const websiteUrl = agentData?.websiteUrl || agentData?.website || ''
    const contactEmail = agentData?.user?.email || agentData?.email || ''
    const contactPhone = agentData?.user?.phone || agentData?.phone || ''
    const address = agentData?.address || agentData?.user?.address || ''
    const city = agentData?.city || ''
    const country = agentData?.country || ''
    const logoUrl = agentData?.logoUrl || agentData?.logoURL || agentData?.logo

    return (
        <div className="card commission-summary-card">
            <div className="header">
                <div className="summary-header-row">
                    <h2>
                        <strong>{t('AGENT_COMMISSIONS_AGENT_INFO_TITLE')}</strong>
                    </h2>
                    <div className="agent-summary-brand">
                        <div className="agent-summary-logo">
                            {logoUrl ? (
                                <img
                                    src={logoUrl}
                                    alt={agentName}
                                    onError={(e) => {
                                        e.target.style.display = 'none'
                                        e.target.nextSibling.style.display = 'flex'
                                    }}
                                />
                            ) : null}
                            <div
                                className="agent-summary-logo-placeholder"
                                style={{ display: logoUrl ? 'none' : 'flex' }}
                            >
                                <i className="zmdi zmdi-account-box"></i>
                            </div>
                        </div>
                        <div className="agent-summary-text">
                            <span className="agent-summary-name">{agentName}</span>
                            {/* <span className="agent-summary-subtitle">
                                {getAgentValue(agentData?.companyName || agentName)}
                            </span> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="body">
                {loading ? (
                    <div className="text-center">
                        <i className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '32px', color: '#f96332' }}></i>
                    </div>
                ) : (
                    <div className="summary-sections">
                        <div className="summary-block summary-block-plain">
                            <div className="summary-section">
                                <h6 className="summary-section-title">{t('AGENT_COMMISSIONS_AGENT_INFO_TITLE')}</h6>
                                <div className="agent-info-list">
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_TABLE_COLUMNS_COMPANY')}</span>
                                        <span className="agent-info-value">{getAgentValue(agentData?.companyName || agentName)}</span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_TABLE_COLUMNS_EMAIL')}</span>
                                        <span className="agent-info-value">{getAgentValue(contactEmail)}</span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_TABLE_COLUMNS_PHONE')}</span>
                                        <span className="agent-info-value">{getAgentValue(contactPhone)}</span>
                                    </div>
                                    <div className="agent-info-row agent-info-row-full">
                                        <span className="agent-info-label">{t('AGENTS_TABLE_COLUMNS_ADDRESS')}</span>
                                        <span className="agent-info-value">{getAgentValue(address)}</span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_TABLE_COLUMNS_CITY')}</span>
                                        <span className="agent-info-value">{getAgentValue(city)}</span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_TABLE_COLUMNS_COUNTRY')}</span>
                                        <span className="agent-info-value">{getAgentValue(country)}</span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_DETAIL_FIELDS_WEBSITE')}</span>
                                        <span className="agent-info-value">
                                            {websiteUrl ? (
                                                <a href={websiteUrl} target="_blank" rel="noreferrer">
                                                    {websiteUrl}
                                                </a>
                                            ) : (
                                                '-'
                                            )}
                                        </span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_DETAIL_FIELDS_TAX_NUMBER')}</span>
                                        <span className="agent-info-value">{getAgentValue(agentData?.taxNumber)}</span>
                                    </div>
                                    <div className="agent-info-row">
                                        <span className="agent-info-label">{t('AGENTS_DETAIL_FIELDS_TAX_OFFICE')}</span>
                                        <span className="agent-info-value">{getAgentValue(agentData?.taxOffice)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="summary-block">
                            <div className="summary-section">
                                <h6 className="summary-section-title">{t('AGENT_COMMISSIONS_SUMMARY_TITLE')}</h6>
                            </div>
                            <div className="summary-grid">
                                <div className="summary-item">
                                    <span className="summary-label">{t('AGENT_COMMISSIONS_SUMMARY_ACCEPTED_STUDENTS')}</span>
                                    <span className="summary-value">
                                        {earningsData.acceptedStudents || commissionDetailData.acceptedStudents || 0}
                                    </span>
                                </div>
                                <div className="summary-item">
                                    <span className="summary-label">{t('AGENT_COMMISSIONS_SUMMARY_TOTAL_EARNINGS')}</span>
                                    <span className="summary-value">
                                        {formatCurrency(
                                            earningsData.totalEarnings ?? commissionDetailData.totalEarnings ?? 0,
                                            commissionDetailData.currency
                                        )}
                                    </span>
                                </div>
                                <div className="summary-item">
                                    <span className="summary-label">{t('AGENT_COMMISSIONS_SUMMARY_TOTAL_PAID')}</span>
                                    <span className="summary-value">
                                        {formatCurrency(earningsData.totalPaid ?? 0, commissionDetailData.currency)}
                                    </span>
                                </div>
                                <div className="summary-item">
                                    <span className="summary-label">{t('AGENT_COMMISSIONS_SUMMARY_REMAINING_BALANCE')}</span>
                                    <span className="summary-value">
                                        {formatCurrency(earningsData.remainingBalance ?? 0, commissionDetailData.currency)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

CommissionSummaryCard.propTypes = {
    loading: PropTypes.bool.isRequired,
    agentName: PropTypes.string.isRequired,
    agentData: PropTypes.object.isRequired,
    earningsData: PropTypes.object.isRequired,
    commissionDetailData: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    formatCurrency: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired
}

export default CommissionSummaryCard

